'use strict';

export default function routes($stateProvider) {
	'ngInject';

	$stateProvider
		.state('login', {
			url: '/login',
			template: require('./login/login.html'),
			controller: 'LoginController',
			controllerAs: 'vm'
		})
		.state('logout', {
			url: '/logout?referrer',
			referrer: 'home',
			template: '',
			controller($state, Auth) {
				'ngInject';

				var referrer = $state.params.referrer || $state.current.referrer || 'home';
				Auth.logout();
				$state.go(referrer);
			}
		})
		// Sergio
		//@{
		.state('signup', {
			url: '/signup',
			template: require('./account/account_new.html'),
			controller: 'AccountNewController',
			controllerAs: 'vm'
		})
		.state('settings', {
			url: '/settings',
			template: require('./account/account_modify.html'),
			controller: 'AccountModifyController',
			controllerAs: 'vm',
			authenticate: true
		})
		.state('justregistered',
		{
			// url -> Oculta
			params: { name: null, email: null }, // Hay que declarar los parametros para poder rellenarlos de forma oculta en el $state.go
			template: require('./other/justregistered.html'),
			controller: function ($scope, $stateParams) {
				$scope.email = $stateParams.email;
				$scope.name = $stateParams.name;
			}
		})
		.state('justactivated',
		{
			url: '/justactivated',
			template: require('./other/justactivated.html'),
		})
		.state('apisuccess',
		{
			url: '/apisuccess/:msg',
			template: require('./other/apisuccess.html'),
			controller: function ($scope, $stateParams) {
				$scope.msg = $stateParams.msg;
				//$scope.msg = $translate.instant($stateParams.msg); // Esto no funciona, es asincrono
				// Esto funciona pero no reacciona al cambio de idioma
				/*$translate($stateParams.msg).then(function(txt) 
					{ $scope.msg3 = txt; });

				$translate($stateParams.msg).then(txt => 
					{ $scope.msg4 = txt; });*/
			}
		})
		.state('apifailed',
		{
			url: '/apifailed/:msg',
			template: require('./other/apifailed.html'),
			controller: function ($scope, $stateParams) {
				$scope.msg = $stateParams.msg;
			}
		})
		.state('resetpassword',
		{
			url: '/resetpassword',
			template: require('./other/resetpassword.html'),
			controller: 'ResetPasswordController',
			controllerAs: 'vm',
			authenticate: false
		})
		.state('changepassword',
		{
			url: '/changepassword/:code',
			template: require('./other/changepassword.html'),
			controller: 'ChangePasswordController',
			controllerAs: 'vm',
			authenticate: false
		})
		.state('resendverificationemail',
		{
			url: '/resendverificationemail',
			template: require('./other/resendverificationemail.html'),
			controller: 'ResendVerificationEmailController',
			controllerAs: 'vm',
			authenticate: false
		});
	//@}
}



// WEBPACK FOOTER //
// ./client/app/account/account.routes.js